export function spSignIn() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'sp_sign_in'
    });
}